import { useEffect, useState } from 'react';
import { getDocumentationAttachmentDownloadUrl } from '../../services/documentationApi';
import {
  extractDocsAttachmentIds,
  replaceDocsAttachmentUrls,
} from '../../utils/documentationInlineAttachments';

type DocumentationHtmlContentProps = {
  html?: string | null;
  pageId?: string | null;
  className?: string;
  emptyHtml?: string;
};

/**
 * HTML da wiki com resolução de docs-attachment:{id} para URLs pré-assinadas.
 */
export function DocumentationHtmlContent({
  html,
  pageId,
  className = '',
  emptyHtml = '<p><em>Sem conteúdo.</em></p>',
}: DocumentationHtmlContentProps) {
  const source = html?.trim() ? html : emptyHtml;
  const [resolvedHtml, setResolvedHtml] = useState(source);

  useEffect(() => {
    let cancelled = false;
    const ids = extractDocsAttachmentIds(source);

    if (ids.length === 0 || !pageId) {
      setResolvedHtml(source);
      return;
    }

    void (async () => {
      const urlById: Record<string, string> = {};
      await Promise.all(
        ids.map(async (id) => {
          try {
            const download = await getDocumentationAttachmentDownloadUrl(pageId, id);
            urlById[id] = download.url;
          } catch {
            // Mantém a referência original se falhar.
          }
        }),
      );

      if (!cancelled) {
        setResolvedHtml(replaceDocsAttachmentUrls(source, urlById));
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [source, pageId]);

  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{ __html: resolvedHtml }}
    />
  );
}
